import React, { useState } from 'react';
import Users from '../components/Users/Users';
import Aside from '../modules/SideNav/Aside';

function UsersLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = value => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Users handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default UsersLayout;
